import Modal from "@/components/modal/modal.vue";
import vClickOutside from "v-click-outside";
import { createNamespacedHelpers } from "vuex";
import moment from "moment";

const { mapActions: userActions } = createNamespacedHelpers("user");

export default {
	props: {
		date_: String,
		type_: String,
		description_: String,
	},

	components: { Modal },

	data() {
		return {
			showCalendar: false,
			date: moment().toDate(),
			description: "",
			type: "",
			missingDesc: false,
			missingType: false,
			attributes: [
				{
					key: "today",
					firstDayOfWeek: 2,
					dates: moment().format(),
				},
			],
			locale: {
				firstDayOfWeek: 2,
				masks: { weekdays: "WWW" },
				id: localStorage.getItem("language") || "en",
			},
			savingAction: false,
			actionTypes: [
				"other",
				"donated_externally",
				"donated_internally",
				"equipment_change",
				"guest_communication",
				"improve_qc",
				"menu_change",
				"recirculate",
				"reduce_portion",
				"reduce_volume",
				"remove_item",
				"style_change",
				"training",
				"storage_change",
				"supplier_change",
				"repurpose",
			].sort((t1, t2) => {
				if (t1 === "other") return -1;
				if (t2 === "other") return 1;
				return this.$t(`tracked_items.action_type_${t1}`).localeCompare(this.$t(`tracked_items.action_type_${t2}`));
			}),
			showTypesList: false,
		};
	},

	computed: {},

	directives: { clickOutside: vClickOutside.directive },

	created() {
		this.date = moment(this.date_).toDate();
		this.description = this.description_ || "";
		this.type = this.type_ || "";
	},

	methods: {
		save,
		updateCalendar,
		hideCalendar,
		addDay,
		toggleTypeDropdown,
		onSelectType,

		...userActions(["getMe"]),
	},
};

async function save() {
	if (!this.type) {
		this.missingType = true;
		return;
	}
	this.missingType = false;

	if (!this.description) {
		this.missingDesc = true;
		return;
	}
	this.missingDesc = false;

	this.$emit("save", moment(this.date).format("YYYY-MM-DD"), this.description, this.type);
	this.savingAction = true;
}

function updateCalendar(val) {
	this.date = moment(val.id).toDate();
	this.hideCalendar();
}

function hideCalendar() {
	this.showCalendar = false;
}

function addDay(days) {
	this.date = moment(this.date).add(days, "days").toDate();
}

function toggleTypeDropdown() {
	this.showTypesList = !this.showTypesList;
}

function onSelectType(type_) {
	this.type = type_;
	this.showTypesList = false;
}
